import React, { FC } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const TickInCircleIcon: FC<SVGComponentProps> = ({
  width = 91,
  height = 90,
  fill = '#16A34A',
  className = undefined
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 91 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M45.5 0C20.75 0 0.5 20.25 0.5 45C0.5 69.75 20.75 90 45.5 90C70.25 90 90.5 69.75 90.5 45C90.5 20.25 70.25 0 45.5 0ZM45.5 81C25.655 81 9.5 64.845 9.5 45C9.5 25.155 25.655 9 45.5 9C65.345 9 81.5 25.155 81.5 45C81.5 64.845 65.345 81 45.5 81ZM66.155 25.11L36.5 54.765L24.845 43.155L18.5 49.5L36.5 67.5L72.5 31.5L66.155 25.11Z"
        fill={fill}
      />
    </svg>
  </SVGUniqueID>
);
export { TickInCircleIcon };
